import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseDashboardProps<T> = {
  filters?: {
    search?: string;
  };
  mapper?: (data: any) => T;
}

export const useDashboards = <T,>({
  filters: { search = '' } = {},
  mapper = Mapper.default<T>(),
}: UseDashboardProps<T>) => {
  const privateAxios = usePrivateAxios();

  const { data: { data, meta } = defaultTransformerResponse<T>(), ...rest } = useQuery({
    queryKey: ['dashboards', search],
    queryFn: () => {
      return privateAxios.get(`/dashboards`, {
        params: {
          search,
        },
      });
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
}
